<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="add()"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>

            <div class="main-toolbar-filter-container">
                <div class="filter-item">
                    <pixl-free-filter-input
                        [label]="'name_or_id' | transloco"
                        [matIcon]="'search'"
                        [hint]="getSearchFilterHint()"
                        [minLength]="freeFilterLen"
                        (onKeyUpChange)="setFreeFilter($event)"
                    />
                </div>
            </div>
        </div>

        <div class="table-container mat-elevation-z4">
            <table
                mat-table
                [dataSource]="(globalMetaData$ | async) || []"
                [trackBy]="trackById"
            >

                <ng-container matColumnDef="actions">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >{{ "actions" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let globalMetaData"
                    >
                        <button
                            [class.btn-success]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="edit(globalMetaData)"
                            [matTooltip]="'edit_record_hint' | transloco"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button
                            [class.btn-danger]="coloredButtonsEnabled()"
                            mat-icon-button
                            color="warn"
                            aria-label="Delete"
                            (click)="delete(globalMetaData)"
                            [matTooltip]="'delete_record_hint' | transloco"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >ID</th>
                    <td
                        mat-cell
                        *matCellDef="let globalMetaData"
                    >{{ globalMetaData.id }}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Name</th>
                    <td
                        mat-cell
                        *matCellDef="let globalMetaData"
                    >{{ globalMetaData.name }}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >{{ "description" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let globalMetaData"
                    >{{ globalMetaData.description }}</td>
                </ng-container>

                <ng-container matColumnDef="fieldConfigName">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >{{ "field_name" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let globalMetaData"
                    >
                        @for (field of globalMetaData.fieldConfig; track field.id || field.name) {
                        <span class="badge badge-dark me-1">
                            {{ field.name }}
                        </span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="fieldConfigDatatype">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >{{ "field_datatype" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let globalMetaData"
                    >
                        @for (field of globalMetaData.fieldConfig; track field.id || field.name) {
                        <span class="badge badge-dark me-1">
                            {{ field.datatype }}
                        </span>
                        }
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.selected-row]="currentSelectedRow() === row.id"
                ></tr>
            </table>
            <mat-paginator
                [pageIndex]="pageChange().pageIndex"
                [pageSize]="pageChange().pageSize"
                [pageSizeOptions]="[25, 50, 100]"
                [length]="totalItems">
            </mat-paginator>
        </div>
    </div>
</div>